/**
 * Codebase 1 Integration Configuration
 * 
 * CONFIGURED WITH ACTUAL API GATEWAY ID: lb9l475n95
 * Region: us-east-1
 * Route: $default (not /dev)
 */

export const CODEBASE1_CONFIG = {
  // WebSocket Connection Endpoint (using $default route)
  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL || 
    'wss://lb9l475n95.execute-api.us-east-1.amazonaws.com/$default',
  
  // Vendor Data API Endpoint
  VENDOR_API_URL: process.env.REACT_APP_VENDOR_API_URL || 
    'https://lb9l475n95.execute-api.us-east-1.amazonaws.com/dev/api/vendors/active',
  
  // Connection Parameters (sent to your WebSocket)
  CONNECTION_PARAMS: {
    type: 'customer',
    timestamp: Date.now()
  },
  
  // Event Types (matching your exact format)
  EVENT_TYPES: {
    VENDOR_ADDED: 'VENDOR_ADDED',
    VENDOR_STATUS_CHANGED: 'VENDOR_STATUS_CHANGED',
    VENDOR_MENU_UPDATED: 'VENDOR_MENU_UPDATED'
  }
};

/**
 * ✅ CONFIGURATION COMPLETE!
 * 
 * WebSocket URL: wss://lb9l475n95.execute-api.us-east-1.amazonaws.com/$default
 * Vendor API URL: https://lb9l475n95.execute-api.us-east-1.amazonaws.com/dev/api/vendors/active
 * 
 * READY TO CONNECT TO CODEBASE 1! 🚀
 */

export default CODEBASE1_CONFIG;
